<template>
	<el-menu v-if="isAuthenticated" :collapse="isCollapse" style="border-right: 0">
		
		<el-menu-item index="dashboard">
			<el-icon>
				<DataLine />
			</el-icon>
			<template #title>Сводка</template>
		</el-menu-item>

		<el-menu-item index="schedule" @click="() => onMenuTabClick(tabsDict.schedule)">
			<el-icon>
				<Tickets />
			</el-icon>
			<template #title>График загрузки</template>
		</el-menu-item>

		<el-menu-item index="orders" @click="() => onMenuTabClick(tabsDict.orders)">
			<el-icon>
				<Coin />
			</el-icon>
			<template #title>Заказ-наряд</template>
		</el-menu-item>

		<el-sub-menu index="1">
			<template #title>
				<el-icon>
					<Memo />
				</el-icon>
				<span>Справочники</span>
			</template>
			<el-menu-item-group>
				<el-sub-menu index="items">
					<template #title>
						<el-icon>
							<MessageBox />
						</el-icon>
						Запчасти
					</template>
					<el-menu-item index="items" @click="() => onMenuTabClick(tabsDict.items)">
						Запчасти
					</el-menu-item>
					<el-menu-item index="itemsgroups" @click="() => onMenuTabClick(tabsDict.itemsGroups)">
						Группы запчастей
					</el-menu-item>
				</el-sub-menu>		
				<el-menu-item index="employees" @click="() => onMenuTabClick(tabsDict.employees)">
					<template #title>
						<el-icon>
							<Avatar />
						</el-icon>
						Сотрудники
					</template>
				</el-menu-item>
				<el-sub-menu index="vehicles">
					<template #title>
						<el-icon>
							<Van />
						</el-icon>
						Автомобили
					</template>
					<el-menu-item index="vehicles-customers" @click="() => onMenuTabClick(tabsDict.vehicles)">						
						Автомобили контрагентов
					</el-menu-item>					
					<el-menu-item index="vehicles-models" @click="() => onMenuTabClick(tabsDict.vehicleModels)">
						Модели
					</el-menu-item>
					<el-menu-item index="vehicles-manufacturers" @click="() => onMenuTabClick(tabsDict.vehicleManufacturers)">
						Марки
					</el-menu-item>
				</el-sub-menu>
				<el-sub-menu index="jobs">
					<template #title>
						<el-icon>
							<OfficeBuilding />
						</el-icon>
						Работы
					</template>
					<el-menu-item index="jobs" @click="() => onMenuTabClick(tabsDict.jobs)">
						Сервисные работы
					</el-menu-item>
					<el-sub-menu index="jobComponents">
						<template #title>
							Сервисные компоненты						
						</template>
						<el-menu-item index="jobComponents" @click="() => onMenuTabClick(tabsDict.jobComponents)">
							Компонеты (узлы)
						</el-menu-item>
						<el-menu-item index="jobComponentGroups" @click="() => onMenuTabClick(tabsDict.jobComponentGroups)">
							Группы компонетов (узлов)
						</el-menu-item>
					</el-sub-menu>
					<el-menu-item index="jobOperations" @click="() => onMenuTabClick(tabsDict.jobOperations)">
						Сервисные операции
					</el-menu-item>
					<el-menu-item index="jobCategories" @click="() => onMenuTabClick(tabsDict.jobCategories)">
						Категории работ
					</el-menu-item>
					<el-menu-item index="jobGroups" @click="() => onMenuTabClick(tabsDict.jobGroups)">
						Группы работ
					</el-menu-item>
				</el-sub-menu>
				<el-menu-item index="counterparties" @click="() => onMenuTabClick(tabsDict.counterparties)">
					<template #title>
						<el-icon>
							<Collection />
						</el-icon>
						Контрагенты
					</template>
				</el-menu-item>
			</el-menu-item-group>
		</el-sub-menu>
		<el-menu-item index="users" @click="() => onMenuTabClick(tabsDict.users)">
			<el-icon>
				<user />
			</el-icon>
			<template #title>Пользователи</template>
		</el-menu-item>
		<!-- <el-menu-item index="settings">
			<el-icon>
				<setting />
			</el-icon>
			<template #title>Настройки</template>
		</el-menu-item> -->
	</el-menu>
	<el-menu v-else default-active="signin" style="border-right: 0" router>
		<el-menu-item index="signin">
			<el-icon><Lock /></el-icon>
			<span>Авторизация</span>
        </el-menu-item>
	</el-menu>
	<div style="position: absolute; bottom: 0;" :style="{'width': `${width}px`}">
		<el-row>
			<el-col>
				<div :class="{'left-menu-toggler': true, 'rotate': isCollapse}" @click="onToggleMenuStyleClick">
					<el-icon><ArrowLeftBold /></el-icon>
				</div>
			</el-col>
		</el-row>
		<div v-if="isAuthenticated" style="display: flex; align-items: center">
			<div style="flex-basis:50px; text-align: left; margin: 0 0 0 .7rem;">
				<el-avatar src="data:image/png;base64,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" />
			</div>
			<div v-if="!isCollapse" style="text-align: left; line-height: .8rem;">
				<el-text size="small" type="info">
					<strong>{{ store.getters.user.login }}</strong>
				</el-text>
				<div>
					<el-text size="small" type="info">
						{{ `${store.getters.user.employee.lastname} ${store.getters.user.employee.firstname?.substring(0,1)}${store.getters.user.employee.firstname?.length ? '.' : ''}` }}
					</el-text>
				</div>
			</div>
		</div>		
	</div>
</template>

<script lang="ts">
import { watch } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { Document, Menu as IconMenu, Location, Setting, DataLine, Memo, Coin, User, Avatar, MessageBox, Lock, Van, OfficeBuilding, Collection, ArrowLeftBold, Tickets } from '@element-plus/icons-vue';
import ApplicationTab from '@/models/ApplicationTab';
import TabsDictionary from '@/variables/tabs';
import store from '@/store';


@Options({
	components: {
		Document, IconMenu, Location, Setting, DataLine, Memo, Coin, User, Avatar, MessageBox, Lock, Van, OfficeBuilding, Collection, ArrowLeftBold, Tickets
	}, 
	props: {
		isAuthenticated: Boolean,
		width: Number,
		collapsed: Boolean
	},
	emits: ['collapse']
})
export default class ApplicationLeftMenuComponent extends Vue {
	/** props */
	width!: number;
	collapsed!: boolean;
	isAuthenticated!: boolean;

	/** constants */
	store = store;
	tabsDict = TabsDictionary;

	/** view-models */
	isCollapse = false;

	mounted(): void {
		watch(
			() => this.collapsed,
			(v) => this.isCollapse = v
		);
	}

	onMenuTabClick(tab: ApplicationTab) {
		store.commit('addTab', tab);
		const newTab = store.getters.newlyAddedTab as ApplicationTab;		
		store.commit('changeTab', newTab.id);
	}	

	onToggleMenuStyleClick() {
		this.isCollapse = !this.isCollapse;
		this.$emit('collapse', this.isCollapse);
	}
}
</script>

<style>
.left-menu-toggler {
	width: 1rem;
	cursor: pointer;
	margin-bottom: .3rem;
	background: var(--el-color-info-light-9);
	border-top: 1px solid var(--el-border-color);
	border-right: 1px solid var(--el-border-color);
	border-bottom: 1px solid var(--el-border-color);
	border-radius: 0 var(--el-border-radius-base) var(--el-border-radius-base) 0;
	padding: .6rem 0 .4rem .24rem;

	transform: translateX(-.222rem);
	transition: transform ease-in-out .3s;
}

	.left-menu-toggler:hover {
		transform: translateX(0);
	}

	.left-menu-toggler .el-icon {
		transform: rotate(0);
		transition: transform ease-in-out .3s;
	}

		.left-menu-toggler.rotate .el-icon {
			transform: rotate(180deg);
		}
</style>